import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Star } from 'lucide-react';
import { OnboardingCard } from '@/components/OnboardingCard';
import { useAuth } from '@/hooks/useAuth';

function OnboardingHub() {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Auth guard - redirect if not authenticated
  React.useEffect(() => {
    if (!user) {
      navigate('/auth');
    }
  }, [user, navigate]);

  if (!user) {
    return null;
  }

  return (
    <div className="min-h-screen bg-background w-full max-w-full overflow-x-hidden">

      <main className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-primary rounded-full mx-auto flex items-center justify-center mb-4">
              <Star className="w-8 h-8 text-primary-foreground" />
            </div>
            <h2 className="text-3xl font-bold mb-2">Complete Your Profile</h2>
            <p className="text-muted-foreground">
              Build your Dino profile by completing these optional steps to get better recommendations and connect with other readers.
            </p>
          </div>

          <OnboardingCard />

          <div className="mt-8 text-center">
            <Button
              variant="outline"
              onClick={() => navigate('/')}
            >
              Continue to Dino
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
}

export default OnboardingHub;